/* Spray tip product page size tool (sections/main-product-tip.liquid, template product.tip).
   The grid cells are the radios of a theme.js [data-variant-picker], so theme.js moves the variant (price, SKU, stock,
   add to cart, ?variant=, photo). This file does the rest:
     coating chips   Graco's rows, the same ranges as snippets/plp-coat-hint and the tip chart page
     paint           the shared picker (paint-picker.js) announces 'ase:paint'; paint-tips.json carries the fan bands
                     (surf) and the surface rules (also: FFLP414 walls, FFLP210 doors, FFLP312 fences)
     ranking         tip-rank.js, the one Best match / Also suits ranking shared with the tip pages and /pages/spray-setup.
                     A coating chip ranks as a Graco guide range (basis graco-guide), so surface rules stay Also suits.
                     Jacob's decisions of 18 Oct 2026: our field guidance leads as the "Field tested pick" with the
                     maker's figures beside it (D2), water based enamels on doors take the trade trim row (D1), a Best
                     match with no fresh in stock read gets the nearest in stock size that suits marked "In stock" (D3,
                     the cell's own ships read), and a surface the paint's sheet rules out gets the reason and no tip (D5)
     readout         code, orifice in thou and mm, fan at 30 cm, Graco water flow at 138 bar (GRACO_FLOW_LPM below, from
                     research/spray-selector/film-build.js, shown only where Graco lists the orifice), Graco coating rows
     sprayer check   the store's sprayers (ase.max_tip, fits: tags), remembered from ?sprayer= or this visit's pick
     tip code key    the picked code worked through
   State: ?coat= ?surface= ?sprayer= (and ?paint= from the picker, ?variant= from theme.js). */
(() => {
  const root = document.querySelector('[data-tip-pdp]');
  if (!root) return;
  const pdp = root.closest('[data-pdp]') || document;
  const $ = (s, r = root) => r.querySelector(s);
  const $$ = (s, r = root) => Array.from(r.querySelectorAll(s));
  const R = window.ASETipRank;
  const EPS = 1e-6;
  const SPRKEY = 'ase.sprayer';
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Graco, Choosing and Understanding Spray Tips (AU): recommended orifice by coating material. A one element o means
     "and up" (Graco prints .025 to .035+). cls maps to the paint classes tip-rank.js knows, so LTX only leads where the
     tip pages let it (membrane and roof, block filler and texture). */
  const COATS = {
    lacquer: { n: 'Lacquer or stain', o: [0.009, 0.013], cls: 'Stains and clears' },
    latex: { n: 'Latex (acrylic)', o: [0.015, 0.019], cls: 'Acrylics and primers' },
    oil: { n: 'Oil based', o: [0.013, 0.015], cls: 'Enamels' },
    heavy: { n: 'Heavy latex or smooth elastomeric', o: [0.021, 0.025], cls: 'Membrane and roof coatings' },
    block: { n: 'Elastomeric and block filler', o: [0.025], cls: 'Block filler and texture' },
  };
  /* Graco water flow at 2000 psi (138 bar), L/min by orifice thou (film-build.js GRACO_FLOW_LPM, graco.com RAC X LP and FFLP tables) */
  const GRACO_FLOW_LPM = { 6: 0.15, 8: 0.26, 10: 0.41, 12: 0.59, 13: 0.69, 14: 0.8, 15: 0.91, 16: 1.04, 17: 1.17, 19: 1.47, 21: 1.79, 23: 2.15, 25: 2.54, 27: 2.96, 29: 3.42, 31: 3.9 };
  const SURF = { wall: 'walls and ceilings', door: 'doors and trim', fence: 'fences' };

  const fmtO = (x) => Number(x).toFixed(3).replace(/^0/, '');
  const thouOf = (o) => Math.round(parseFloat(o) * 1000);
  /* 2.5 cm to the inch, as the tip chart prints it (spray-tip-chart.liquid) */
  const cmOf = (inch) => Math.round(inch * 2.5);
  /* "an 8 in fan", "an 18 in fan", "a 10 in fan" */
  const aN = (n) => { const t = String(n); return /^8/.test(t) || t === '11' || t === '18' ? 'an' : 'a'; };
  const mmOf = (o) => (parseFloat(o) * 25.4).toFixed(2);
  const read = (sel) => { const el = pdp.querySelector(sel); try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; } };

  const stockMeta = read('[data-variant-stock-meta]');
  const cells = $$('[data-tp-cell]');
  const grid = $('[data-variant-picker]');
  const vById = new Map();
  try { JSON.parse(grid.querySelector('script[type="application/json"]').textContent).forEach((x) => vById.set(String(x.id), x)); } catch (e) { /* theme.js keeps working without it */ }
  const sc = $('[data-tp-scroll]');
  const table = sc ? sc.querySelector('table') : null;
  const byId = new Map(cells.map((c) => [c.dataset.id, c]));
  const picker = $('[data-paint-picker]');
  const paintBox = $('[data-tp-paint]');
  const paintBtn = $('[data-tp-paint-open]');
  const paintLabel = $('[data-tp-paint-label]');
  const status = $('[data-tp-status]');
  const sprSel = $('[data-tp-sprayer]');
  const sprOut = $('[data-tp-spr-out]');
  const family = root.dataset.family || '';

  let data = { also: {}, surf: { wall: [8, 12], door: [4, 8], fence: [6, 10] } };
  let coat = '';
  let paint = null;
  let surface = '';
  let job = '';
  let userMoved = false;
  const startVariant = new URLSearchParams(location.search).has('variant');

  /* ---------- Stock per cell: the same rules and 25 hour age check as theme.js stockLine / snippets/stock-label.liquid.
     Keep the three in step. Only a fresh in stock read marks a cell. ---------- */
  function shipsNow(id) {
    const v = stockMeta && stockMeta.variants && stockMeta.variants[id];
    if (!v) return false;
    if (v.own && stockMeta.source !== 'graco_portal') return true;
    /* GO's own shelf at Deception Bay (ase.go_stock), a read under 49 hours, as stock-label.liquid and theme.js goQty */
    const g = v.go;
    if (stockMeta.source === 'graco_portal' && g && Number.isInteger(g.qty) && g.qty > 0 && (Date.now() - Date.parse(g.checked_at)) / 3600e3 < 49) return true;
    if (stockMeta.source !== 'graco_portal' || !v.portal) return false;
    let st = v.portal.status;
    if (!st && v.stock_status === 'Ships now') st = 'in_stock';
    if (st !== 'in_stock' && st !== 'low') return false;
    return Math.floor((Date.now() / 1000 - (Number(v.ts) || 0)) / 3600) < 25;
  }
  cells.forEach((c) => {
    const ships = shipsNow(c.dataset.id);
    c.closest('td, .tp-loose__i').classList.toggle('is-ships', ships);
    c.dataset.ships = ships ? '1' : '';
  });

  /* ---------- What is being sprayed: a paint record or a Graco coating row, as tip-rank.js reads them ---------- */
  const source = () => {
    if (paint) return paint;
    if (coat && COATS[coat]) {
      const c = COATS[coat];
      return { id: `coat-${coat}`, b: 'Graco', n: c.n, o: c.o, cls: c.cls, basis: 'graco-guide', gc: c.n.toLowerCase() };
    }
    return null;
  };
  const sizeOf = (c) => ({ code: c.dataset.code, orifice: c.dataset.orifice, fan: c.dataset.fan, sizeCode: c.dataset.sizeCode, ships: c.dataset.ships ? '1' : '0' });
  const current = () => cells.find((c) => c.checked) || null;

  const setMark = (c, txt, sr) => {
    const l = c.nextElementSibling;
    if (!l) return;
    const m = l.querySelector('[data-tp-mark]');
    const s = l.querySelector('[data-tp-sr]');
    if (m) m.textContent = txt;
    if (s) s.textContent = sr;
  };

  let lastRank = { best: null, also: [], inRange: new Set(), active: false };
  function apply({ pick = false } = {}) {
    /* D5: a surface the paint's own sheet rules out: the reason, and the grid filtered by the surface alone */
    const fit = paint && surface ? R.suitedTo(paint, surface) : { ok: null };
    const p = fit.ok === false ? null : source();
    const active = !!(p || surface);
    const rankOn = !!(p && surface && !p.na);
    const pool = [];
    const inRange = new Set();
    cells.forEach((c) => {
      if (!c.dataset.orifice) return;
      const d = sizeOf(c);
      let ok;
      if (p && surface) {
        const a = R.admit(p, d, surface, data);
        ok = !!a;
        if (a) pool.push({ c, d, extra: a.extra });
      } else if (p) {
        ok = !R.hasRule(p) || R.suits(p, d);
      } else if (surface) {
        ok = R.inBand(d, surface, data);
      } else ok = true;
      if (ok) inRange.add(c);
    });
    const rk = rankOn ? R.rank(p, surface, pool, data) : { best: null, also: [], inStock: null };
    const { best, inStock } = rk;
    const also = rk.also.filter((x) => x !== inStock);
    lastRank = { best, also, inStock, inRange, active, p };

    root.classList.toggle('is-filtered', active);
    cells.forEach((c) => {
      const td = c.closest('td, .tp-loose__i');
      const isBest = !!best && best.c === c;
      const isAlso = also.some((x) => x.c === c);
      const isNow = !!inStock && inStock.c === c;
      td.classList.toggle('is-in', active && inRange.has(c));
      td.classList.toggle('is-out', active && !inRange.has(c));
      td.classList.toggle('is-best', isBest);
      td.classList.toggle('is-also', isAlso || isNow);
      const vj = vById.get(c.dataset.id);
      const sold = !!vj && !vj.available;
      const noPrice = !!vj && !(vj.price > 0);
      const stockSr = `${c.dataset.ships ? ', ships now' : ''}${sold ? ', sold out' : ''}${noPrice ? ', email us for a price' : ''}`;
      td.classList.toggle('is-sold', sold);
      if (isBest) setMark(c, 'Best', `, best match${stockSr}`);
      else if (isNow) setMark(c, 'In stock', `, in stock now, the nearest size to the best match${stockSr}`);
      else if (isAlso) setMark(c, 'Also', `, also suits${stockSr}`);
      else setMark(c, sold ? 'Sold out' : '', `${active && !inRange.has(c) ? ', not suited to this job' : ''}${stockSr}`);
    });

    /* Status line under the chips */
    status.textContent = '';
    /* Sentences join with one space, never a leading one */
    const add = (t, cls) => { if (status.childNodes.length && !cls) status.appendChild(document.createTextNode(' ')); const el = document.createElement('span'); if (cls) el.className = cls; el.textContent = t; status.appendChild(el); return el; };
    const what = p ? (paint ? `${paint.b} ${paint.n}` : p.n) : paint ? `${paint.b} ${paint.n}` : '';
    const band = surface ? ((data.surf || {})[surface] || []) : [];
    if (fit.ok === false) {
      add(`${fit.text}. No tip is suggested for ${what} there.`, 'tp-status__best');
    } else if (rankOn) {
      if (best) add(`Best match ${best.code} for ${what} on ${SURF[surface]}.`, 'tp-status__best');
      /* D2 / D1: our own pick, with the maker's figures beside it */
      if (best && rk.label) add(`${rk.label}.${rk.sheet ? ` ${rk.sheet.text}.` : ''}`);
      /* D3 */
      if (inStock) add(`In stock now ${inStock.code}, the nearest size that suits. ${best.code} has no stock showing today.`);
      if (also.length) add(`Also suits ${also.map((x) => x.code).join(', ')}.`);
      if (!best && !also.length) add(pool.length ? `No ${family} size stands out for ${what} on ${SURF[surface]}. The marked sizes are in range.` : `No ${family} size suits ${what} on ${SURF[surface]}. Try another family or ask us.`);
      /* An estimate paint has no data sheet of its own: its wet coat is the figure estimated from similar paints' sheets (as plp.js) */
      if (best && best.speed && paint && paint.w) {
        add(paint.basis === 'estimate'
          ? `At about 110 bar and a steady pass of about ${best.speed.toFixed(1)} m/s, ${best.code} lays about ${paint.w} µm wet per coat, the figure estimated from similar paints' data sheets.`
          : `At about 110 bar and a steady pass of about ${best.speed.toFixed(1)} m/s, ${best.code} lays the ${paint.w} µm wet coat the ${paint.b} data sheet asks for.`, 'tp-status__note');
      }
    } else if (p && !p.na) {
      const n = inRange.size;
      if (R.hasRange(p)) add(`${what}: ${p.o.length === 1 ? `${fmtO(p.o[0])} and up` : `${fmtO(p.o[0])} to ${fmtO(p.o[1])}`} orifice. ${n ? `${n} size${n === 1 ? '' : 's'} here in range.` : 'No size here in range.'} Pick what you're painting for the best match.`);
      else if (R.hasRule(p)) add(`${what}: ${n ? `${n} size${n === 1 ? '' : 's'} here suit it.` : 'none of these sizes are on its list.'} Pick what you're painting for the best match.`);
      else add(`No spray settings on file for ${what}. Pick what you're painting to narrow the fan, or ask us.`);
    } else if (p && p.na) {
      add(p.note || `No spray settings on file for ${what}.`);
      /* D2: our own field note beside the maker's line */
      if (R.fieldNote && R.fieldNote(p)) add(R.fieldNote(p));
    } else if (surface) {
      add(`${SURF[surface][0].toUpperCase()}${SURF[surface].slice(1)}: ${band[0]} to ${band[1]} in fan. Pick what you're spraying for the best match.`);
    }

    /* Move to the Best match when the painter changed the question (or a shared link named no size) */
    if (best && (pick || (!startVariant && !userMoved))) choose(best.c);
    else showMarked();
    refresh();
  }

  /* Bring cells into the grid's view without moving the page: the first one always, the rest when they fit beside it,
     clear of the pinned Hole column, scrolling no further than it has to */
  function reveal(list, smooth = true) {
    if (!sc) return;
    const tds = list.map((c) => c && c.closest('td')).filter(Boolean);
    if (!tds.length) return;
    const box = sc.getBoundingClientRect();
    const pinEl = sc.querySelector('thead th.tp-ori');
    const pin = pinEl ? pinEl.getBoundingClientRect().width : 0;
    const pad = 8;
    const room = sc.clientWidth - pin - pad * 2;
    const at = (td) => { const r = td.getBoundingClientRect(); return [r.left - box.left + sc.scrollLeft, r.right - box.left + sc.scrollLeft]; };
    let [lo, hi] = at(tds[0]);
    tds.slice(1).forEach((td) => { const [l, r] = at(td); const nl = Math.min(lo, l); const nh = Math.max(hi, r); if (nh - nl <= room) { lo = nl; hi = nh; } });
    const cur = sc.scrollLeft;
    let next = cur;
    if (lo < cur + pin + pad) next = lo - pin - pad;
    else if (hi > cur + sc.clientWidth - pad) next = hi - sc.clientWidth + pad;
    next = Math.max(0, Math.min(next, sc.scrollWidth - sc.clientWidth));
    if (Math.abs(next - cur) > 1) sc.scrollTo({ left: next, behavior: smooth && !reduce ? 'smooth' : 'auto' });
  }
  const showMarked = (smooth = true) => reveal([current(), lastRank.best && lastRank.best.c, ...lastRank.also.map((x) => x.c), lastRank.inStock && lastRank.inStock.c], smooth);

  function choose(c) {
    if (!c || c.checked) { showMarked(); refresh(); return; }
    c.checked = true;
    c.dispatchEvent(new Event('change', { bubbles: true }));
    showMarked();
  }

  /* ---------- Readout, sprayer check and tip code key for the picked size ---------- */
  const setText = (sel, t) => { const el = $(sel); if (el) el.textContent = t; };
  function grRows(o) {
    const t = thouOf(o);
    return Object.values(COATS).filter((c) => t >= Math.round(c.o[0] * 1000) && (c.o.length === 1 || t <= Math.round(c.o[1] * 1000))).map((c) => c.n.toLowerCase());
  }
  function refresh() {
    const c = current();
    if (!c) return;
    const code = c.dataset.code;
    pdp.querySelectorAll('[data-tp-code]').forEach((el) => { el.textContent = code; });
    /* theme.js enables Add to cart on availability alone; a size with no price can't be bought here either */
    const vj = vById.get(c.dataset.id);
    if (vj && !(vj.price > 0)) pdp.querySelectorAll('[data-atc]').forEach((b) => { b.disabled = true; });
    photoNote();
    setText('[data-tp-r-code]', code);
    const o = c.dataset.orifice;
    const f = parseFloat(c.dataset.fan);
    const has = !!o && !Number.isNaN(f);
    setText('[data-tp-r-ori]', has ? `${fmtO(o)} in, ${mmOf(o)} mm` : 'Not on file');
    setText('[data-tp-r-fan]', has ? `${f} in, about ${cmOf(f)} cm` : 'Not on file');
    const flow = has ? GRACO_FLOW_LPM[thouOf(o)] : undefined;
    const flowRow = $('[data-tp-r-flow-row]');
    if (flowRow) flowRow.hidden = flow === undefined;
    setText('[data-tp-r-flow]', flow !== undefined ? `${flow.toFixed(2)} L/min of water at 138 bar (Graco). Paint flows less.` : '');
    const rows = has ? grRows(o) : [];
    setText('[data-tp-r-suits]', rows.length ? `${rows.join(', ').replace(/^./, (x) => x.toUpperCase())}` : has && thouOf(o) < 9 ? 'Below Graco\'s coating rows, which start at .009' : 'No Graco coating row for this hole');

    /* This size against the paint or coating picked */
    const pRow = $('[data-tp-r-paint-row]');
    const p = lastRank.p;
    if (pRow) {
      pRow.hidden = !p;
      if (p) {
        const td = c.closest('td, .tp-loose__i');
        setText('[data-tp-r-paint-dt]', paint ? 'Your paint' : 'Your coating');
        const name = paint ? `${paint.b} ${paint.n}` : p.n;
        let t;
        if (td.classList.contains('is-best')) t = `Best match for ${name}${surface ? ` on ${SURF[surface]}` : ''}.`;
        else if (lastRank.inStock && lastRank.inStock.c === c) t = `In stock now, the nearest size to the best match for ${name}${surface ? ` on ${SURF[surface]}` : ''}.`;
        else if (td.classList.contains('is-also')) t = `Also suits ${name}${surface ? ` on ${SURF[surface]}` : ''}.`;
        else if (lastRank.inRange.has(c)) t = `In range for ${name}${surface ? ` on ${SURF[surface]}` : ''}.`;
        else t = `Not suited to ${name}${surface ? ` on ${SURF[surface]}` : ''}.`;
        setText('[data-tp-r-paint]', t);
      }
    }
    sprayerCheck(c);
    tipKey(c);
  }

  function sprayerCheck(c) {
    if (!sprSel || !sprOut) return;
    sprOut.textContent = '';
    const opt = sprSel.value ? sprSel.options[sprSel.selectedIndex] : null;
    if (!opt) { sprOut.textContent = 'Pick your sprayer to check it runs this size.'; sprOut.dataset.state = ''; return; }
    const name = opt.textContent.split(' · ')[0].trim();
    const code = c.dataset.code;
    const max = parseFloat(opt.dataset.max);
    const o = parseFloat(c.dataset.orifice);
    if (opt.dataset.fits === 'no') {
      sprOut.dataset.state = 'no';
      sprOut.textContent = `We don't list the ${family} for the ${name}. Check the handpiece and guard it takes, or ask us before you buy.`;
      return;
    }
    if (Number.isNaN(max)) {
      sprOut.dataset.state = 'unknown';
      sprOut.textContent = `We don't have a max tip on file for the ${name}, so we can't check ${code} against it. Ask us before you buy.`;
      return;
    }
    if (Number.isNaN(o)) { sprOut.dataset.state = 'unknown'; sprOut.textContent = `${code} has no orifice on file to check.`; return; }
    if (o <= max + EPS) {
      sprOut.dataset.state = 'yes';
      sprOut.textContent = `Yes. The ${name} runs ${code}: its max tip is ${fmtO(max)} and this is a ${fmtO(o)} hole.`;
      return;
    }
    /* Too big: the nearest size this family has that it runs, same fan first, else the closest fan */
    const f = parseFloat(c.dataset.fan);
    const ok = cells.filter((x) => x.dataset.orifice && parseFloat(x.dataset.orifice) <= max + EPS);
    ok.sort((a, b) => {
      const fa = Math.abs(parseFloat(a.dataset.fan) - f);
      const fb = Math.abs(parseFloat(b.dataset.fan) - f);
      return fa - fb || parseFloat(b.dataset.orifice) - parseFloat(a.dataset.orifice);
    });
    const near = ok[0];
    sprOut.dataset.state = 'no';
    sprOut.append(`No. The ${name} tops out at a ${fmtO(max)} tip and ${code} is a ${fmtO(o)} hole, so it's too big for it.`);
    if (near) {
      sprOut.append(' The nearest size it runs is ');
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'tp-spr__use';
      b.textContent = near.dataset.code;
      /* The button goes when the line is rebuilt, so focus moves to the line that now answers it */
      b.addEventListener('click', () => { userMoved = true; choose(near); sprOut.focus({ preventScroll: true }); });
      sprOut.appendChild(b);
      sprOut.append(` (${fmtO(near.dataset.orifice)} hole, ${near.dataset.fan} in fan).`);
    } else {
      sprOut.append(` No ${family} size is small enough for it.`);
    }
  }

  function tipKey(c) {
    const sc = String(c.dataset.sizeCode || '').replace(/\D/g, '');
    const fam = String(c.dataset.code || '').slice(0, Math.max(0, String(c.dataset.code || '').length - sc.length));
    const o = c.dataset.orifice;
    const f = parseFloat(c.dataset.fan);
    if (sc.length < 3 || !o || Number.isNaN(f)) {
      setText('[data-tp-k-fam]', c.dataset.code || '');
      setText('[data-tp-k-fan]', '');
      setText('[data-tp-k-ori]', '');
      setText('[data-tp-k-fan-w]', '');
      setText('[data-tp-k-ori-w]', '');
      return;
    }
    const fd = sc.slice(0, -2);
    const od = sc.slice(-2);
    setText('[data-tp-k-fam]', fam);
    setText('[data-tp-k-fan-dt]', fd.length > 1 ? 'First two digits × 2' : 'First digit × 2');
    setText('[data-tp-k-fan]', fd);
    setText('[data-tp-k-ori]', od);
    /* Only say the code decodes to the fan on file when it does, never the other way round */
    const decoded = Number(fd) * 2;
    setText('[data-tp-k-fan-w]', decoded === f ? `${fam}${sc}: ${fd} × 2 = ${aN(f)} ${f} in fan, about ${cmOf(f)} cm.` : `${fam}${sc}: the fan on file is ${f} in, about ${cmOf(f)} cm.`);
    setText('[data-tp-k-ori-w]', thouOf(o) === Number(od) ? `${od} = a ${fmtO(o)} in hole, ${mmOf(o)} mm.` : `The hole on file is ${fmtO(o)} in, ${mmOf(o)} mm.`);
  }

  /* ---------- Chips ---------- */
  const press = (box, attr, val) => $$(`[${attr}]`, box).forEach((b) => b.setAttribute('aria-pressed', String(b.getAttribute(attr) === val)));
  /* Job chips (FFLP family): the size each one picks, our experience and not a Graco rating. A job chip is pressed when its
     surface is on and its size is the one picked; with no job tapped (a shared ?surface= link) the first chip of the surface leads. */
  const JOB_DEFAULT = { wall: '514', door: '312' };
  const pressSurf = () => $$('[data-tp-surf]', surfBox).forEach((b) => {
    const own = b.dataset.tpJob;
    const on = b.dataset.tpSurf === surface && (!own || own === (job || JOB_DEFAULT[surface]));
    b.setAttribute('aria-pressed', String(on));
  });
  const jobCell = (n) => cells.find((c) => c.dataset.sizeCode === n && /^FFLP/.test(c.dataset.code || ''));
  /* Stock on each job chip, from the same per size read the page already carries (data-variant-extras, the stock-label line) */
  const extras = read('[data-variant-extras]') || {};
  const stockWord = (c) => {
    if (!c) return '';
    if (c.dataset.ships) return 'In stock';
    const h = (extras[c.dataset.id] || {}).stock || '';
    if (/stock--out/.test(h)) return 'On order';
    if (/stock--low/.test(h)) return 'Low stock';
    if (/stock--in/.test(h)) return 'Check stock';
    return '';
  };
  const setJobChips = () => $$('[data-tp-job]', surfBox).forEach((b) => {
    const c = jobCell(b.dataset.tpJob);
    const out = b.querySelector('[data-tp-job-s]');
    if (!c) { b.hidden = true; return; }
    const w = stockWord(c);
    if (out) { out.textContent = `${b.dataset.tpJob}${w ? ` · ${w}` : ''}`; out.dataset.state = w === 'In stock' ? 'in' : w === 'On order' ? 'out' : w ? 'low' : ''; }
  });
  /* The page opens on the first recommended size that is in stock, not on the first size in the family */
  const defaultJobSize = () => {
    if (startVariant) return;
    const first = ['514', '312', '210'].map(jobCell).find((c) => c && c.dataset.ships);
    if (first && !first.checked) { first.checked = true; first.dispatchEvent(new Event('change', { bubbles: true })); }
  };
  const coatBox = $('[data-tp-coats]');
  const surfBox = $('[data-tp-surfs]');
  const loadData = () => (picker && picker.paintPicker ? picker.paintPicker.load() : Promise.resolve());
  const toUrl = () => {
    const u = new URL(location.href);
    if (coat) u.searchParams.set('coat', coat); else u.searchParams.delete('coat');
    if (surface) u.searchParams.set('surface', surface); else u.searchParams.delete('surface');
    const s = sprSel && sprSel.value;
    if (s) u.searchParams.set('sprayer', s); else u.searchParams.delete('sprayer');
    history.replaceState(history.state, '', u.pathname + u.search + u.hash);
  };
  let quietPaint = false;
  coatBox.addEventListener('click', (e) => {
    const b = e.target.closest('[data-tp-coat]');
    if (!b) return;
    coat = coat === b.dataset.tpCoat ? '' : b.dataset.tpCoat;
    press(coatBox, 'data-tp-coat', coat);
    if (coat && paint) {
      paint = null;
      quietPaint = true;
      if (picker && picker.paintPicker) picker.paintPicker.select(null);
      setPaintChip();
    }
    openPaint(false);
    userMoved = true;
    toUrl();
    loadData().then(() => apply({ pick: true }));
  });
  surfBox.addEventListener('click', (e) => {
    const b = e.target.closest('[data-tp-surf]');
    if (!b) return;
    const was = b.getAttribute('aria-pressed') === 'true';
    surface = was ? '' : b.dataset.tpSurf;
    job = was ? '' : (b.dataset.tpJob || '');
    pressSurf();
    if (picker && picker.paintPicker && picker.paintPicker.setSurface) picker.paintPicker.setSurface(surface);
    userMoved = true;
    toUrl();
    const jc = job ? jobCell(job) : null;
    loadData().then(() => { apply({ pick: !jc }); if (jc) choose(jc); });
  });

  /* "Pick your paint" opens the shared picker under the chips */
  function openPaint(open) {
    if (!paintBox) return;
    paintBox.hidden = !open;
    paintBtn.setAttribute('aria-expanded', String(open));
    if (open) {
      loadData();
      const bar = $('[data-tp-bar]');
      const top = paintBox.getBoundingClientRect().top;
      const off = (bar ? bar.offsetHeight : 0) + (parseFloat(root.style.getPropertyValue('--tp-top')) || 0) + 8;
      if (top < off || top > innerHeight - 120) window.scrollBy({ top: top - off, behavior: 'smooth' });
      const brand = picker && picker.querySelector('[data-pp-brand][aria-pressed="true"]') ? picker.querySelector('[data-pp-input]') : picker && picker.querySelector('[data-pp-brand]');
      if (brand && window.matchMedia('(pointer: fine)').matches) setTimeout(() => brand.focus({ preventScroll: true }), 250);
    }
  }
  function setPaintChip() {
    paintBtn.classList.toggle('is-active', !!paint);
    paintLabel.textContent = paint ? `${paint.b} ${paint.n}` : 'Pick your paint';
  }
  paintBtn.addEventListener('click', () => openPaint(paintBox.hidden));
  if (picker) {
    picker.addEventListener('ase:paint-ready', (e) => { if (e.detail && e.detail.data) data = { ...data, ...e.detail.data }; apply(); });
    picker.addEventListener('ase:paint', (e) => {
      if (e.detail && e.detail.data) data = { ...data, ...e.detail.data };
      const next = (e.detail && e.detail.paint) || null;
      if (quietPaint && !next) { quietPaint = false; return; }
      quietPaint = false;
      paint = next;
      if (paint && coat) { coat = ''; press(coatBox, 'data-tp-coat', ''); toUrl(); }
      setPaintChip();
      const restored = !userMoved && startVariant;
      if (!restored) userMoved = true;
      apply({ pick: !restored });
    });
  }

  /* ---------- Sprayer ---------- */
  if (sprSel) {
    sprSel.addEventListener('change', () => {
      try { if (sprSel.value) sessionStorage.setItem(SPRKEY, sprSel.value); else sessionStorage.removeItem(SPRKEY); } catch (e) { /* storage blocked */ }
      toUrl();
      const c = current();
      if (c) sprayerCheck(c);
    });
  }

  /* ---------- The grid: keep the readout in step with theme.js's variant change ---------- */
  grid.addEventListener('change', (e) => { if (e.target.matches('[data-tp-cell]')) { if (e.isTrusted) userMoved = true; refresh(); } });

  /* The readout's and the sticky bar's Add to cart submit the one product form, so theme.js adds the picked size */
  pdp.querySelectorAll('[data-tp-atc]').forEach((b) => b.addEventListener('click', () => {
    const btn = pdp.querySelector('[data-product-form] [type=submit]');
    if (btn && !btn.disabled) btn.click();
  }));

  /* Sticky offsets: the chip bar sits under the header; the readout under the bar */
  const bar = $('[data-tp-bar]');
  const setBar = () => root.style.setProperty('--tp-bar', `${bar.offsetHeight}px`);
  setBar();
  if ('ResizeObserver' in window) new ResizeObserver(setBar).observe(bar);
  /* The header sticks on some pages and scrolls away on others, so the bar sits under whatever of it is on screen */
  const hdr = document.querySelector('.site-header');
  let raf = 0;
  const setTop = () => {
    raf = 0;
    const b = hdr ? Math.max(0, Math.round(hdr.getBoundingClientRect().bottom)) : 0;
    root.style.setProperty('--tp-top', `${b}px`);
  };
  setTop();
  window.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(setTop); }, { passive: true });
  window.addEventListener('resize', setTop, { passive: true });
  /* A stuck bar gets its rule */
  const stuck = () => bar.classList.toggle('is-stuck', bar.getBoundingClientRect().top <= (parseFloat(root.style.getPropertyValue('--tp-top')) || 0) + 1 && root.getBoundingClientRect().top < 0);
  window.addEventListener('scroll', stuck, { passive: true });

  /* ---------- Keyboard: arrows move around the grid by row and column (focus only), Space or Enter picks ---------- */
  const matrix = table ? Array.from(table.tBodies[0].rows).map((tr) => Array.from(tr.cells).slice(1).map((td) => td.querySelector('[data-tp-cell]'))) : [];
  const where = (c) => { for (let r = 0; r < matrix.length; r += 1) { const k = matrix[r].indexOf(c); if (k > -1) return [r, k]; } return null; };
  grid.addEventListener('keydown', (e) => {
    const c = e.target;
    if (!c.matches || !c.matches('[data-tp-cell]')) return;
    if (e.key === 'Enter') { e.preventDefault(); if (!c.checked) { userMoved = true; choose(c); } return; }
    const pos = where(c);
    if (!pos) return;
    const step = { ArrowLeft: [0, -1], ArrowRight: [0, 1], ArrowUp: [-1, 0], ArrowDown: [1, 0] }[e.key];
    let to = null;
    if (step) {
      let [r, k] = pos;
      for (;;) {
        r += step[0]; k += step[1];
        if (r < 0 || r >= matrix.length || k < 0 || k >= matrix[r].length) break;
        if (matrix[r][k]) { to = matrix[r][k]; break; }
      }
    } else if (e.key === 'Home' || e.key === 'End') {
      const row = matrix[pos[0]].filter(Boolean);
      to = e.key === 'Home' ? row[0] : row[row.length - 1];
    } else return;
    e.preventDefault();
    if (to && to !== c) { to.focus({ preventScroll: true }); reveal([to]); clearBar(to); }
  });

  /* ---------- Nothing that takes focus hides under the stuck chips bar (or the pinned headings) ---------- */
  function clearBar(t) {
    updHead();
    let cover = bar.getBoundingClientRect().bottom;
    if (headIn && !headIn.hidden && grid.contains(t)) cover = Math.max(cover, headIn.getBoundingClientRect().bottom);
    const el = t.matches('[data-tp-cell]') ? t.closest('td, .tp-loose__i') : t;
    const r = el.getBoundingClientRect();
    if (r.top < cover + 4) window.scrollBy({ top: r.top - cover - 8, behavior: 'instant' });
  }
  root.addEventListener('focusin', (e) => {
    const t = e.target;
    if (bar.contains(t)) return;
    /* After the browser's own scroll into view, which runs once focus has moved */
    setTimeout(() => { if (document.activeElement === t) clearBar(t); }, 0);
  });

  /* ---------- Pinned fan headings: a copy of the thead under the chips once the real one has scrolled away ---------- */
  const headWrap = $('[data-tp-head]');
  const headIn = $('[data-tp-head-in]');
  let headTable = null;
  function sizeHead() {
    if (!headTable || !table) return;
    headTable.style.width = `${table.getBoundingClientRect().width}px`;
    const real = Array.from(table.tHead.rows[0].cells);
    Array.from(headTable.tHead.rows[0].cells).forEach((th, i) => { const w = real[i] ? `${real[i].getBoundingClientRect().width}px` : ''; th.style.width = w; th.style.minWidth = w; });
    headIn.scrollLeft = sc.scrollLeft;
  }
  function updHead() {
    if (!headIn || !table || !table.tHead) return;
    const line = headWrap.getBoundingClientRect().top;
    const th = table.tHead.getBoundingClientRect();
    const tb = table.getBoundingClientRect();
    const show = th.bottom < line && tb.bottom > line + th.height + 24;
    if (show && !headTable) {
      headTable = table.cloneNode(false);
      headTable.removeAttribute('id');
      headTable.appendChild(table.tHead.cloneNode(true));
      headIn.appendChild(headTable);
    }
    if (show === headIn.hidden) { headIn.hidden = !show; if (show) sizeHead(); }
    root.style.setProperty('--tp-headh', show ? `${headIn.offsetHeight}px` : '0px');
  }
  if (headIn && sc) {
    window.addEventListener('scroll', updHead, { passive: true });
    window.addEventListener('resize', () => { sizeHead(); updHead(); }, { passive: true });
    sc.addEventListener('scroll', () => { headIn.scrollLeft = sc.scrollLeft; }, { passive: true });
  }

  /* ---------- Chip rows that run off a phone screen fade at the edge they continue past ---------- */
  const edges = (b) => {
    const over = b.scrollWidth - b.clientWidth;
    b.classList.toggle('is-more-r', over > 2 && b.scrollLeft < over - 2);
    b.classList.toggle('is-more-l', over > 2 && b.scrollLeft > 2);
  };
  [coatBox, surfBox].forEach((b) => { if (!b) return; edges(b); b.addEventListener('scroll', () => edges(b), { passive: true }); });
  window.addEventListener('resize', () => [coatBox, surfBox].forEach((b) => b && edges(b)), { passive: true });
  /* The size grid: when it runs wider than the screen, fade its right edge and say so until it has been swiped */
  const swipe = $('[data-tp-swipe]');
  const gridEdges = () => {
    if (!sc) return;
    const over = sc.scrollWidth - sc.clientWidth;
    const more = over > 2 && sc.scrollLeft < over - 2;
    sc.classList.toggle('is-more-r', more);
    if (swipe) swipe.hidden = !more;
  };
  if (sc) { gridEdges(); sc.addEventListener('scroll', gridEdges, { passive: true }); window.addEventListener('resize', gridEdges, { passive: true }); if ('ResizeObserver' in window && table) new ResizeObserver(gridEdges).observe(table); }
  if ('ResizeObserver' in window) new ResizeObserver(() => edges(coatBox)).observe(paintBtn);

  /* ---------- Photo note: every photo here is of one size, so say which one when it isn't the size picked ---------- */
  const gal = pdp.querySelector('[data-pdp-gallery]');
  const track = gal && gal.querySelector('[data-pg-track]');
  const slides = track ? Array.from(track.querySelectorAll('.pg__slide')) : [];
  const shotOf = new Map();
  vById.forEach((x) => { if (x.featured_media) shotOf.set(String(x.featured_media), x.sku); });
  slides.forEach((sl) => {
    const id = sl.dataset.slideId;
    if (shotOf.has(id)) return;
    /* A photo no size claims: its alt text ends in the size code ("RAC X WideRAC LP SwitchTip 1221") */
    const img = sl.querySelector('img');
    const m = img && (img.alt || '').match(/(\d{3,4})\s*$/);
    const c = m && cells.find((x) => String(x.dataset.sizeCode || '').replace(/\D/g, '') === m[1]);
    if (c) shotOf.set(id, c.dataset.code);
  });
  let note = null;
  let shownIdx = 0;
  if (track && shotOf.size) {
    note = document.createElement('p');
    note.className = 'tp-photo';
    note.hidden = true;
    const stage = gal.querySelector('.pg__stage');
    (stage || track).insertAdjacentElement('afterend', note);
    /* Which photo is up: the thumb or arrow that moved it (theme.js clicks the variant's thumb), else where a swipe left it */
    const thumbs = Array.from(gal.querySelectorAll('[data-pg-go]'));
    const curThumb = thumbs.findIndex((b) => b.getAttribute('aria-current') === 'true');
    shownIdx = curThumb > -1 ? curThumb : 0;
    const to = (i) => { shownIdx = Math.max(0, Math.min(slides.length - 1, i)); photoNote(); };
    thumbs.forEach((b) => b.addEventListener('click', () => to(Number(b.dataset.pgGo))));
    const prev = gal.querySelector('[data-pg-prev]');
    const next = gal.querySelector('[data-pg-next]');
    if (prev) prev.addEventListener('click', () => to(shownIdx - 1));
    if (next) next.addEventListener('click', () => to(shownIdx + 1));
    let pr = 0;
    track.addEventListener('scroll', () => { clearTimeout(pr); pr = setTimeout(() => to(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))), 120); }, { passive: true });
  }
  function photoNote() {
    if (!note) return;
    const c = current();
    const sl = slides[shownIdx];
    const shown = sl && shotOf.get(sl.dataset.slideId);
    if (!c || !shown || shown === c.dataset.code) { note.hidden = true; return; }
    note.textContent = `Photo shows ${shown}. No photo of ${c.dataset.code} yet.`;
    note.hidden = false;
  }

  /* ---------- Restore ---------- */
  const q = new URLSearchParams(location.search);
  if (COATS[q.get('coat')] && !q.get('paint')) { coat = q.get('coat'); press(coatBox, 'data-tp-coat', coat); }
  if (SURF[q.get('surface')]) { surface = q.get('surface'); pressSurf(); }
  setJobChips();
  defaultJobSize();
  if (sprSel) {
    const fromUrl = q.get('sprayer');
    let want = fromUrl;
    if (!want) { try { want = sessionStorage.getItem(SPRKEY); } catch (e) { want = null; } }
    if (want && Array.from(sprSel.options).some((o) => o.value === want)) {
      sprSel.value = want;
      /* A sprayer named in a link is this visit's sprayer too */
      if (fromUrl) { try { sessionStorage.setItem(SPRKEY, want); } catch (e) { /* storage blocked */ } }
    }
  }
  /* Bring the picked cell into view on a phone so a deep link to LTX 6xx doesn't open on the 2 in column */
  reveal([current()], false);
  apply();
  if (coat || surface) loadData().then(() => apply());
})();
